import React, { FC, memo } from 'react';
import { Typography, TypographyProps } from '~/shared/components';
import styles from './category-card-text.module.css';
import { Link as CallToActionLink } from '~/lib/data-contract';
import RightArrow from '$icons/arrow-right.svg';
import clsx from 'clsx';

type Props = {
    headline?: string;
    text?: string;
    backgroundColor?: string;
    isDarkShade?: boolean;
    isMainCategory?: boolean;
    callToAction?: CallToActionLink;
    titleAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    withLink?: boolean;
    className?: string;
    ctaText?: string;
    lineClampText?: TypographyProps<'p'>['lineClamp'];
    lineClampHeadline?: TypographyProps<'h3'>['lineClamp'];
};

const CategoryCardText: FC<Props> = memo((props) => {
    const {
        headline,
        text,
        backgroundColor,
        isDarkShade,
        isMainCategory,
        titleAs = 'h3',
        withLink,
        className,
        lineClampText,
        lineClampHeadline,
        ctaText,
    } = props;

    return (
        <div
            style={{ backgroundColor }}
            className={clsx(
                withLink ? styles.rootWithLink : styles.root,
                isDarkShade && 'inverted-colors',
                className
            )}
        >
            <div className={styles.textWrapper}>
                {headline && (
                    <Typography
                        variant={isMainCategory ? 'display3' : 'display4'}
                        as={titleAs}
                        isDarkBackground={isDarkShade}
                        lineClamp={lineClampHeadline}
                    >
                        {headline}
                    </Typography>
                )}
                {text && (
                    <Typography
                        variant={isMainCategory ? 'bodySm' : 'bodyXs'}
                        isDarkBackground={isDarkShade}
                        lineClamp={headline ? lineClampHeadline : lineClampText}
                    >
                        {text}
                    </Typography>
                )}
            </div>
            {withLink && (
                <span className={styles.cta} title={ctaText}>
                    <Typography
                        className={styles.ctaText}
                        variant="link"
                        as="span"
                        isDarkBackground={isDarkShade}
                    >
                        {ctaText}
                    </Typography>
                    <RightArrow className={styles.icon} />
                </span>
            )}
        </div>
    );
});

CategoryCardText.displayName = 'CategoryCardText';

export { CategoryCardText };
